import { useEffect, useState } from 'react';
import { MFAEnrollmentStatus, User } from '@tcc/shared-data-lib';
import { setCookie, getCookie } from '../utils/cookies';

interface useMFADialogProps {
  user?: User;
  featureFlags?: Record<string, boolean | undefined>;
}

export function useMFADialog({ user, featureFlags }: useMFADialogProps) {
  const [showMFADialog, setShowMFADialog] = useState(false);

  useEffect(() => {
    const isMFAFlagActive = featureFlags?.['web.multi-factor-authentication'];
    if (isMFAFlagActive && user && user.details) {
      const isMFADismissed = getCookie('mfa_dialog_dismissed') === 'true';
      if (!isMFADismissed) {
        setShowMFADialog(user.details.preferences.mfaEnrollmentStatus === MFAEnrollmentStatus.ELIGIBLE);
      }
    }
  }, [featureFlags, user]);

  const handleMFACancel = () => {
    setCookie({ value: 'true', expiresInMinutes: 4320, key: 'mfa_dialog_dismissed' });
    setShowMFADialog(false);
  };

  return {
    showMFADialog,
    setShowMFADialog,
    handleMFACancel,
  };
}
